export default __webpack_public_path__ + "static/media/element_1.31639d14.svg";